import React, { Component } from 'react';
import { Input, Button } from 'antd';

/*
const locationIcon = {
  url: 'http://api0.map.bdimg.com/images/copyright_logo.png',
  size: { width: 100, height: 100 },
};
*/

export default class extends Component {
  constructor(props) {
    super(props);

    this.setMapRef = ref => {
      this.mapContainer = ref;
    };
  }

  componentDidMount() {
    this.createMapScript().then(this.initMap);
  }

  componentWillReceiveProps(nextProps) {
    const { onChange } = this.props;
    if (nextProps.site && nextProps.site != '') {
      console.log('nextProps.site',nextProps.site)
      setTimeout(()=>{
        this.onSearch(nextProps.site)
      },1000) 
      
    }
    if (this.inited) return;
    if (!this.mapLoaded) return;
    if (nextProps.value == null) return;
    // console.log(nextProps.value, this.props.value)
    const { value } = nextProps;
    const { point: position = { lng: undefined, lat: undefined } } = value;
    const { point: prePosition = { lng: undefined, lat: undefined } } = this.props.value || {};

    if (position.lng && position.lat && !prePosition.lng && !prePosition.lat) {
      // console.log(position)
      const point = new global.BMap.Point(position.lng, position.lat);
      console.log('point', point)
      this.map.panTo(point);
      if (this.marker) {
        this.marker.setPosition(point);
      } else {
        this.marker = new global.BMap.Marker(point);
        this.map.addOverlay(this.marker);
      }
      this.inited = true;
    }

  }

  shouldComponentUpdate() {
    return !this.inited;
  }

  componentWillUnmount() {
    if (this.map) {
      this.map.removeEventListener('click', this.onMapClick);
      this.map = null;
    }
  }

  onMapClick = event => {
    const { onChange } = this.props;
    const { point } = event;
    // this.setState({ mapCenter: { lng: point.lng, lat: point.lat } });

    this.map.panTo(new global.BMap.Point(point.lng, point.lat));
    if (this.marker) {
      this.marker.setPosition(point);
    } else {
      this.marker = new global.BMap.Marker(point);
      this.map.addOverlay(this.marker);
    }

    const myGeo = new global.BMap.Geocoder();
    myGeo.getLocation(point, result => {
      if (onChange) onChange(result);
    });
  };

  onSearch = value => {
    if (!this.localSearch && this.map !=undefined) {
      console.log("this.map:", this.map)
      this.localSearch = new global.BMap.LocalSearch(this.map, {
        renderOptions: { map: this.map },
      });
    }
    if (this.localSearch) {
      this.localSearch.search(value);
    }
  };

  onClear = () => {
    if (this.localSearch) {
      this.localSearch.clearResults();
    }
  };

  setCity = (city, zoom) => {
    this.map.setCenter(city);
    if (zoom) this.map.setZoom(zoom);
  };

  initMap = BMap => {
    // this.defaultCenter = getPoint(116.404, 39.915);
    // this.mapContainer = this.mapContainer || this.mapContainerRef.current;
    const { value, onChange } = this.props;
    const { point: position } = value || {};
    // console.log("position:", position)

    // console.log(this.props)

    const map = new BMap.Map(this.mapContainer, { enableMapClick: false });
    if (Object.keys(map).length === 0) return;
    // map.enableScrollWheelZoom();
    const point = new BMap.Point(
      (position && position.lng) || 102.71346343485244,
      (position && position.lat) || 25.068697812426223
    );
    // console.log("point:", point)
    map.centerAndZoom(point, 15);
    map.setDefaultCursor('pointer');
    // var bdary = new BMap.Boundary();
    // bdary.get('云南省昆明市五华区', function (rs) {       //获取行政区域       
    //     //for循环都删除掉了，只剩下这个
    //     //网上查了下，东西经南北纬的范围
    //     var EN_JW = "180, 90;";         //东北角
    //     var NW_JW = "-180,  90;";       //西北角
    //     var WS_JW = "-180, -90;";       //西南角
    //     var SE_JW = "180, -90;";        //东南角
    //     //4.添加环形遮罩层
    //     var ply1 = new BMap.Polygon(rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, { strokeColor: "none", fillColor: "rgb(246,246,246)", fillOpacity:1, strokeOpacity: 0.5 }); //建立多边形覆盖物

    //     map.addOverlay(ply1);  
    //     //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
    //     var ply = new BMap.Polygon(rs.boundaries[0], { strokeWeight: 2, strokeColor: "#00f",fillColor: "" });
    //     map.addOverlay(ply); 
    //   });
    // map.setViewport(ply.getPath());    //调整视野
    // map.addControl(new BMap.OverviewMapControl({ isOpen: true, size: new BMap.Size(140, 110) }));
    // map.addControl(new BMap.NavigationControl({type: global.BMAP_NAVIGATION_CONTROL_ZOOM}));
    map.addControl(new BMap.NavigationControl());



    // map.addEventListener('tilesloaded', ()=>{
    // });
    if (position && position.lng && position.lat) {
      this.marker = new BMap.Marker(point);
      map.addOverlay(this.marker);
    } else {
      // const myCity = new BMap.LocalCity();
      // myCity.get(result => {
      //   // console.log(result)
      //   map.setCenter(result.name);
      // });
    }
    map.addEventListener('click', this.onMapClick);
    console.log('map', map);
    const myGeo = new global.BMap.Geocoder();
    // 初始化时默认定位
    // myGeo.getLocation(point, result => {
    //   if (onChange) onChange(result);
    // });
    this.map = map;
    this.mapLoaded = true;
  };

  createMapScript = () => {
    const ak = '9bU4xYWwRh0XOpvf07nlCFKrcbab4OYy';

    window.BMap = window.BMap || {};
    if (Object.keys(window.BMap).length === 0) {
      window.BMap.b_preload = new Promise(resolve => {
        const $script = document.createElement('script');
        document.body.appendChild($script);
        window.b_initBMap = () => {
          resolve(window.BMap);
          document.body.removeChild($script);
          window.BMap.b_preload = null;
          window.b_initBMap = null;
        };

        $script.src = `https://api.map.baidu.com/api?v=3.0&ak=${ak}&callback=b_initBMap`;
      });
      return window.BMap.b_preload;
    }

    if (!window.BMap.b_preload) {
      return Promise.resolve(window.BMap);
    }
    return window.BMap.b_preload;
  };

  render() {
    const { width = '100%', height = 400, style, hideInput } = this.props;
    const { value } = this.props;
    let  pointvalue="";
    if(value&&value.point){
      let point =value.point;
      if(point.lat&&point.lng){
        pointvalue=point.lat+","+point.lng;
      }
     
    }
    return (
      <div style={{ border: 'solid 1px #e1e1e1', marginBottom: 16, borderRadius: 5 }}>
        {/* {
          hideInput ? null :
            <div>
              <Input.Search
                enterButton="查询"
                size="small"
                placeholder="请输入经纬度或地区定位查询"
                style={{ width: '50%', minWidth: 240, marginBottom: 8, marginTop: 8, marginLeft: 8 }}
                onSearch={this.onSearch}
                defaultValue={pointvalue}
                allowClear={true}
              />
              <Button type="dashed" size="small"  style={{ marginLeft: 8 }} onClick={this.onClear}>
                清除
        </Button>
            </div>
        } */}
        <div ref={this.setMapRef} style={{ width, height, ...style }} />
      </div>
    );
  }
}